import React, { useState } from 'react'
import Container from 'components/Container'
import BigNumber from 'bignumber.js'
import { Link as HistoryLink } from 'react-router-dom'
import { Host } from 'data/Host'
import { Lock } from 'data/Lock'
import { HostList } from 'data/HostList'
import { getSigner } from 'utils'
import useToast from 'hooks/useToast'
import { MaxUint256 } from '@ethersproject/constants'
import InputNumber from 'components/InputNumber'
import { AutoRow, RowBetween } from 'components/Row'
import { useTranslation } from 'react-i18next'
import Countdown from 'react-countdown'
import { Contract } from 'ethers'
import { Button, CardBody, useModal } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import { HOST_ADDRESS, USDT } from '../../constants'
import Token_ABI from '../../constants/abis/erc20.json'
import HOST_ABI from '../../constants/abis/host.json'
import { useActiveWeb3React } from '../../hooks'
import AddBnbModal from './AddBnbModal'
import AppBody from '../AppBody'
import { Wrapper, TopBox, TriggerText, HostingText, DescText, ButtonText, CommonText, ContentBox,
    EarningCountdown, CountdownBox, EarningText, CountdownContent, IncomeBox, Title, InputBox,
     InputTitle, WarnTip, TabBox, TabItem, RecordBox, RecordItem, RecordSection, NoMore, 
} from './styleds'
// import hostImg from '../../assets/images/host.png'

// import downImg from '../../assets/images/arrow_down.png'

export default function Hosting() {
    const { account, chainId, library } = useActiveWeb3React()
    const TranslateString = useI18n()
    
    const renderer = ({ hours, minutes, seconds }) => {
        return <CountdownContent><span>{hours}</span>小时<span>{minutes}</span>分钟<span>{seconds}</span>秒</CountdownContent>;
      };
      const {
        userInfo,
        rewardInfo,
        bnbBalance,
        tokenBalance,
        tokenAllowance,
        usdtAmount
      }:any = Host(account ?? undefined)
     
      const lockInfo:any = Lock('111111', account ?? undefined)

      const { t } = useTranslation()
      const [tokenAmount, setTokenAmount] = useState('');
      const [bnbAmount, setBnbAmount] = useState('');
      const [approveLoading, setApproveLoading] = useState(false);
      const [hostLoading, setHostLoading] = useState(false);
      const [addLoading, setAddLoading] = useState(false);
      const [receiveLoading, setReceiveLoading] = useState(false);
      const [ page, setPage ] = useState(1)
      const [active, setActive] = useState(1);
      const [ goPage, setGoPage ] = useState(page)

      // const [redeemLoading, setRedeemLoading] = useState(false);
      const { toastSuccess, toastError } = useToast()

      const  { recordList, totalPage } = HostList(page, account ?? undefined)

      const handleActive = value => {
        if(value === active) return
        setActive(value)
      }
      const handleTokenInput = value => {
        setTokenAmount(value)
      }
      const handleBnbInput = value => {
        setBnbAmount(value)
      }
      const handleAddBnb = async bnbValue => {
        if (!chainId || !library || !account) return
        setAddLoading(true)
         try {
           const contract = new Contract(HOST_ADDRESS, HOST_ABI, getSigner(library, account))
           const bnbNum = new BigNumber(10 ** 18).multipliedBy(bnbValue).toFixed()
          
           const tx = await contract.addBnbFee({ value: bnbNum })
           await tx.wait();
           setAddLoading(false)
           toastSuccess(t('Successfully added'))
         } catch(err) {
      
          setAddLoading(false)
           toastError(t('Failed to added'))
         }
      }
      const [onAddBnb] = useModal(<AddBnbModal bnbBalance={bnbBalance} translateString={TranslateString} loading={ addLoading } handleAddBnb={ handleAddBnb } />)
     
      const handleApprove = async () => {
     
        if (!chainId || !library || !account) return
        setApproveLoading(true)
         try {
           const contract = new Contract(USDT.address, Token_ABI,getSigner(library, account))
           const tx = await contract.approve(HOST_ADDRESS, MaxUint256)
           // eslint-disable-next-line no-console
          await tx.wait();
          setApproveLoading(false)
           toastSuccess(t('Approve successful'))
         } catch {
          setApproveLoading(false)
           toastError(t('Approve failed'))
         }
       }
       const handleHost = async () => {
     
        if (!chainId || !library || !account) return
        setHostLoading(true)
         try {
           const contract = new Contract(HOST_ADDRESS, HOST_ABI, getSigner(library, account))
           const num = new BigNumber(tokenAmount).multipliedBy(`${10 ** 18}`).toFixed()
           const value = bnbAmount && Number(bnbAmount) > 0 ? new BigNumber(bnbAmount).multipliedBy(`${10 ** 18}`).toString() : 0
           const tx = await contract.userLockHosting(num, { value })
           // eslint-disable-next-line no-console
          await tx.wait();
           setHostLoading(false)
           toastSuccess(t('Successfully hosted'))
         } catch(err) {
           setHostLoading(false)
           toastError(t('Failed to hosted'))
         }
       }
       const handleReceive = async () => {
     
        if (!chainId || !library || !account) return
        setReceiveLoading(true)
         try {
           const contract = new Contract(HOST_ADDRESS, HOST_ABI, getSigner(library, account))
           const tx = await contract.withdrawReward()
           // eslint-disable-next-line no-console
          await tx.wait();
          setReceiveLoading(false)
           toastSuccess(t('Successfully receive'))
         } catch(err) {
          setReceiveLoading(false)
           toastError(t('Failed to receive'))
         }
       }
       const handleRedeem = async () => {
     
        if (!chainId || !library || !account) return
        // setRedeemLoading(true)
         try {
           const contract = new Contract(HOST_ADDRESS, HOST_ABI, getSigner(library, account))
           const tx = await contract.quit()
          await tx.wait();
          // setRedeemLoading(false)
           toastSuccess(t('Successfully redeem'))
         } catch(err) {
          // setRedeemLoading(false)
           toastError(t('Failed to redeem'))
         }
       }
       const handleGoPage = (value) => {
         setGoPage(value)
       }
       const switchPage = () => {
         setPage(goPage)
       }
       const reducePage = () => {
         setPage(page - 1)
       }
       const addPage = () => {
        setPage(page + 1)
      }
  return (
    <Container>
    <AppBody>
      <Wrapper>
         <TopBox>
            <TriggerText>{ t('Automatic trigger') }</TriggerText>
            <HostingText style={{ marginBottom: '8px' }}>{ userInfo ? userInfo.balance : '0.000' } <span>MEME</span></HostingText>
            <DescText style={{ marginBottom: '15px' }}>≈ {usdtAmount} USDT</DescText>
            <AutoRow justify='center' gap='5px' style={{ marginBottom: '15px' }}>
              <DescText>({ t('Fully automatic hosting') })</DescText>
              <ButtonText onClick={ handleRedeem }>{ t('Redeem') }</ButtonText>
            </AutoRow>
            <AutoRow justify='center' gap='5px'>
              <CommonText>{ t('Gas fee remaining') }：{ userInfo ? userInfo.bnbFee : '0.000' } DST ({ userInfo ? Math.floor(userInfo.bnbFee/0.003) : 0 } { t('number') })</CommonText>
              <ButtonText onClick={onAddBnb}>{ t('Add now') }</ButtonText>
            </AutoRow>
         </TopBox>
         <ContentBox>
         { rewardInfo &&  Number(rewardInfo.reward)> 0 && !rewardInfo.canWithdraw ? (<EarningCountdown>
                <CountdownBox>
                  <Countdown daysInHours date={ rewardInfo.endTime * 1000 } renderer={ renderer }/>
                </CountdownBox>
                <EarningText>{ t('can be unlocked later') } { rewardInfo.reward } MEME</EarningText>
         </EarningCountdown>) : (<></>) }
         <IncomeBox>
           <RowBetween marginBottom='15px' align='top'>
             <div style={{ flex: 1 }}>
               <CommonText style={{ fontSize: '13px', marginBottom: '10px' }}>{ t('Lock up') }</CommonText>
               { lockInfo && lockInfo.userLocks.length > 0 ? (
                <>
                  {lockInfo.userLocks.map((item) => (
                   <CommonText key={ item.tokenAddress } style={{ fontSize: '13px', marginBottom: '10px' }}><b style={{fontSize: '16px', color: '#1EC7D3', marginRight: '10px'}}>{ Number(item.amount / 10 ** item.decimals).toFixed(3) } { item.symbol }</b>({ t('Lock')})</CommonText>
                  ))}
                </>
              ) : (
                <CommonText>0.000</CommonText>
              )}
             </div>
             <HistoryLink to="/airdrop"><Button minWidth='130px' marginBottom='10px'>{ t('Lock up now') }</Button></HistoryLink>
           </RowBetween>
           <RowBetween>
             {/* <div>
                <CommonText style={{ fontSize: '13px', marginBottom: '10px' }}>{ t('Locked amount') }</CommonText>
                <CommonText style={{ fontWeight: 'bold', fontSize: '15px' }}>{ lockInfo && lockInfo.userLockAmount ? Number(lockInfo.userLockAmount/10**18).toFixed(3) : '0.000' } MEME</CommonText>
             </div> */}
             <div>
                <CommonText style={{ fontSize: '13px', marginBottom: '10px', textAlign: 'left' }}>{ t('Pending receipt') }</CommonText>
                <CommonText style={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'left' }}>{ rewardInfo && rewardInfo.canWithdraw ? rewardInfo.reward : '0.000' } MEME</CommonText>
             </div>
           </RowBetween>
         </IncomeBox>
         <Button width="100%" onClick={ handleReceive } disabled={ receiveLoading } marginBottom='10px'>{ receiveLoading ?  `${ t('Receive') }...` : t('Receive')}</Button>
         </ContentBox>
      </Wrapper>
     
      </AppBody>
         {/* <HostIconBox>
            <HostIcon src={ hostImg } width='115px' height='150px' />
          </HostIconBox> */}
      <AppBody>
        
        <Wrapper>
          
            <Title>
              { t('Fully automatic host') }
            </Title>
            
            <CardBody>
            <CommonText style={{ fontSize: '13px', marginBottom: '15px', lineHeight: '23px' }}>{ t('Fully automatic escrow contract, DST can be paid in advance, no need to manually trigger the execution of the escrow contract, and it will be automatically triggered after the airdrop is unlocked, which is more convenient.') }</CommonText>
             <InputBox>
               <RowBetween>
                <InputTitle>{ t('Fully automatic escrow contract') }</InputTitle>
                <InputTitle>{ t('Balance:') }{ tokenBalance } USDT</InputTitle>
               </RowBetween>
               <InputNumber value={ tokenAmount } placeholder={ t('Please enter the quantity') } onUserInput={ handleTokenInput }/>
             </InputBox>
             <InputBox>
             <RowBetween>
               <InputTitle>{ t('Fully automatic trigger gas fee entry') }</InputTitle>
                <InputTitle>{ t('Balance:') }{ bnbBalance } DST</InputTitle>
               </RowBetween>
               
               <InputNumber placeholder={ t('Please enter the quantity') } value={ bnbAmount } onUserInput={ handleBnbInput }/>
             </InputBox>
             { !tokenAmount ? (<Button width="100%" disabled marginBottom='20px'>{ t('Please enter the escrow quantity') }</Button>) :
               Number(tokenAmount) > Number(tokenBalance) ? 
               (<Button width="100%" disabled marginBottom='20px'>{ t('Insufficient USDT balance') }</Button>): 
               
               Number(tokenAllowance) < Number(tokenAmount) ? (<Button width="100%" disabled={ approveLoading } onClick={ handleApprove } marginBottom='20px'>{ approveLoading ? `${t('Approve')}...` : `${t('Approve')} USDT` }</Button>) :
               
               (<Button width="100%" onClick={ handleHost } disabled={ hostLoading } marginBottom='20px'>{ hostLoading ? `${ t('Host now') }...` : t('Host now') }</Button>)
             }
             <WarnTip>
             { t('host_desc1') }<br />
             { t('host_desc2') }
             </WarnTip>
          </CardBody>
        </Wrapper>
      </AppBody>
      <AppBody>
        <Wrapper>
         <TabBox>
          <RowBetween>
            <TabItem className={ Number(active) === 1 ? 'active' : ''} onClick={(event) => {
                  event.stopPropagation()
                  handleActive(1)
              }}>{ t('Record') }</TabItem>
            <TabItem className={ Number(active) === 2 ? 'active' : ''} onClick={(event) => {
                  event.stopPropagation()
                  handleActive(2)
              }}>{ t('Code') }</TabItem>
            <TabItem className={ Number(active) === 3 ? 'active' : ''} onClick={(event) => {
                  event.stopPropagation()
                  handleActive(3)
              }}>{ t('Permission drop') }</TabItem>
          </RowBetween>
         </TabBox>
         { active === 1 ? 
         (<RecordBox>
           {  recordList.length > 0 ? recordList.map((item) => (
           <RecordItem key={ item.id + item.sellMemeAmount }>
             <RecordSection >
               <CommonText style={{ fontSize: '15px', color: '#1EC7D3', marginBottom: '10px', fontWeight: 'bold' }}>{ t('Escrow contracts are automatically executed') }</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA'}}>Gas：{item.bnbFee} DST</CommonText>
             </RecordSection>
             { Number(item.sellMemeAmount) > 0 ? (<RecordSection> 
               <CommonText style={{ fontSize: '14px', color: '#311765', marginBottom: '10px', fontWeight: 'bold' }}>{ t('Escrow contracts are automatically sold') }</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t("Selling quantity") }：{ item.sellMemeAmount } MEME</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Selling price') }：{ Number(item.sellUsdtAmount / item.sellMemeAmount).toFixed(3) } USDT/MEME</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Total turnover')}：{ item.sellUsdtAmount } USDT</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Time') }：{ item.time }</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#FF8F17' }}>{ t('Managed Assets') }：0 MEME&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ item.sellUsdtAmount } USDT</CommonText>
             </RecordSection>) : <></>}
             <RecordSection> 
               <CommonText style={{ fontSize: '14px', color: '#311765', marginBottom: '10px', fontWeight: 'bold' }}>{ t('Escrow contracts automatically buy') }</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Buy quantity') }：{ item.buyUsdtAmount } USDT</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Buy price') }：{ Number(item.buyUsdtAmount / item.buyMemeAmount).toFixed(3) } USDT/MEME</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Total turnover') }：{ item.buyMemeAmount } MEME</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Time') }：{ item.time }</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#FF8F17' }}>{ t('Managed Assets') }：{ item.buyMemeAmount } MEME&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0 USDT</CommonText>
             </RecordSection>
             <RecordSection> 
               <CommonText style={{ fontSize: '14px', color: '#311765', marginBottom: '10px', fontWeight: 'bold' }}>{ t('Escrow contract reward collection') }</CommonText>
               <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '8px' }}>{ t('Receive quantity') }：{ item.reward } MEME</CommonText>
             </RecordSection>
           </RecordItem> )) : <NoMore>{ t('No records') }</NoMore>}
           <RowBetween marginTop='20px' marginBottom='15px'>
           <Button style={{ fontSize: '13px', padding: 0, borderRadius: '10px' }} width="80px" height='30px' onClick={ reducePage } disabled={ page <= 1 }>{ t('Prev') }</Button>
           <div style={{ width: '80px', height: '30px' }}><InputNumber style={{ height: '30px', borderRadius: '10px' }} value={ goPage } onUserInput={ handleGoPage }/></div>
           <Button style={{ fontSize: '13px', padding: 0, borderRadius: '10px' }} width="40px" height='30px' onClick={ switchPage }>GO</Button>
           <Button style={{ fontSize: '13px', padding: 0, borderRadius: '10px' }} width="80px" height='30px' disabled={ page >= totalPage } onClick={ addPage }>{ t('Next') }</Button>
         </RowBetween>
         </RecordBox>) : <></>}
        

         { active === 2 ? (<RecordBox>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Escrow contract open source code viewing link') }</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>https://bscscan.com/block/0xb11a806ce8e5f07618a563e74e8c9572e7c23a797638bd6f63c41822095ac7b</CommonText>
         </RecordBox>) : <></> }
         { active === 3 ? (<RecordBox>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Escrow contract permission drop view link') }</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>https://bscscan.com/block/0xb11a806ce8e5f07618a563e74e8c9572e7c23a797638bd6f63c41822095ac7b</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Escrow contract address') }:</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>0xb11a806ce8e5f07618a563e74e8c9572e7c23a</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#7A6EAA', marginBottom: '10px' }}>{ t('Escrow contract permissions discard hash records') }:</CommonText>
           <CommonText style={{ fontSize: '13px', color: '#1EC7D3', marginBottom: '10px', lineHeight: '20px' , wordBreak: 'break-all' }}>https://bscscan.com/block/0xb11a806ce8e5f07618a563e74e8c9572e7c23a797638bd6f63c41822095ac7b</CommonText>
         </RecordBox>) : <></> }
        </Wrapper>
      </AppBody>
    </Container>
  )
}